import React, { Dispatch, useState, useEffect, useRef } from 'react';
import { ModalContainer, StyledAsterisco } from './styles';
import { Col, Row, Form, Select, Button, Modal, Tooltip, Space, notification, Input, message } from 'antd';
import { CloseOutlined, PlusCircleOutlined, WarningOutlined } from '@ant-design/icons';
import CriaPedidoEntrega from '../../submodules/entregaNoCd/components/CriaPedidoEntrega';
import ModalNovoItem from './components/ModalNovoItem';
import ModalTransportadora from './components/ModalTransportadora';
import ModalVeiculo from './components/ModalVeiculo';
import ModalMotorista from './components/ModalMotorista';
import SelectTomadorTransp from './components/ModalNovoItem/components/SelectTomador/selectTomador';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from '../../../../store';
import { Action } from 'typesafe-actions';
import { cleanOrdemCarga } from '../../../../store/ducks/ordemCarga/actions';
import { IOrdemCarga } from '../../../../store/ducks/ordemCarga/types';
import { SelectInscricao } from '../../../../components/SelectInscricao';
import { ROLE } from '../../../../utils/roles';
import { TextLabel } from 'components/TextLabel';
import TitlePage from 'components/TitlePage';
import Swal from 'sweetalert2';
import { ItensColeta } from '../../submodules/coletaNoCd';
import ModalCriarAgendamento from '../ModalCriarAgendamento';
import { ModalCriarAgendamentoRef } from '../ModalCriarAgendamento';

import api from 'service/api';
import { SKW_PREFIX } from 'utils/constants';
import { AxiosResponse } from 'axios';
import mask from 'utils/mask';

interface ModalCriarOrdemDeColetaProps {
  tipoWms: string;
  itensSelected?: ItensColeta[] | undefined;
  setaArraySelectedItens: React.Dispatch<React.SetStateAction<ItensColeta[] | undefined>>;
  atualizaTabelaEntrega?: () => void;
  atualizaTabelaColeta?: () => void;
}

const ModalCriarOrdemDeColeta: React.FC<ModalCriarOrdemDeColetaProps> = ({
  tipoWms,
  itensSelected = [],
  setaArraySelectedItens,
  atualizaTabelaEntrega,
  atualizaTabelaColeta,
}) => {
  const { Option } = Select;
  const dispatch = useDispatch<Dispatch<Action>>();
  const cddAtivo = useSelector((state: ApplicationState) => state.auth?.cddAtivo);
  const pedidoEntrega: any = useSelector((state: ApplicationState) => state.PedidoEntrega.data);
  const loadingAddItem = useSelector((state: ApplicationState) => state.OrdemCarga.loading);
  const perfil = useSelector((state: ApplicationState) => state.auth?.user?.perfil);
  const inscricaoAtiva = useSelector((state: ApplicationState) => state.auth.inscricaoAtiva);
  const codCdd = useSelector((state: ApplicationState) => state.auth.cddAtivo?.codCdd);
  const token = useSelector((state: ApplicationState) => state.auth?.token);
  const parceiros = useSelector((state: ApplicationState) => state.auth.user?.inscricoesEstaduais);
  const isPossibleNewEmptyColect = useSelector((state: ApplicationState) => state.auth.user?.isPossibleNewEmptyColect);

  const [selectedTomadorOrdemCarga, setSelectedTomadorOrdemCarga] = useState<number | null>(null);
  const [selectedTipodecarga, setSelectedTipodecarga] = useState<string>('');
  const [selectedMotorista, setSelectedMotorista] = useState<number | null>(null);
  const [selectedVeiculo, setSelectedVeiculo] = useState<number | null>(null);
  const [codTipValue, setCodTipValue] = useState<number | null>(null);
  const [assoalho, setAssoalho] = useState<string>('');
  const [transportadoraKey, setTransportadoraKey] = useState<number | null>(null);
  const [clienteRetira, setClienteRetira] = useState<boolean>(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [data, setData] = useState<any>([]);
  const [order, setOrder] = useState<IOrdemCarga>();
  const [loading, setLoading] = useState(false);
  const [disableField, setDisableField] = useState(false);
  const [peso, setPeso] = useState<string>("");

  const modalCriarAgendamentoRef = useRef<ModalCriarAgendamentoRef>(null);

  useEffect(() => {
    if (pedidoEntrega !== undefined && Array.isArray(pedidoEntrega) === false) {
      new Promise<void>((resolve, reject) => {
        // eslint-disable-next-line array-callback-return
        data.map((item: any) => {
          if (item.numNota === pedidoEntrega.numNota) return reject();
        });
        return resolve();
      })
        .then(() => {
          setData([...data, pedidoEntrega]);
        })
        .catch(() => {
          openNotification('Documento já adicionado');
        });
    }
    return;
    // eslint-disable-next-line
  }, [pedidoEntrega]);


  useEffect(() => {
    if (transportadoraKey &&
      selectedTomadorOrdemCarga) {
      setDisableField(true)
    } else {
      setDisableField(false)
    }
  }, [transportadoraKey, selectedTomadorOrdemCarga])

  let ArraynuNotas: number[];
  if (itensSelected && itensSelected?.length > 0) {
    ArraynuNotas = itensSelected?.reduce(
      (acc: number[], item) => acc.concat(item?.nuNotaPedido),
      []
    );
  } else {
    ArraynuNotas = data.reduce((acc: number[], item: any) => acc.concat(item.nuNota), []);
  }

  const handleConfirmation = async () => {

    if (tipoWms === 'EXP' && itensSelected?.length === 0 && !peso) return message.error("Selecione um documento ou adicione o peso!")


    setLoading(true);

    api
      .post(`call?serviceName=${SKW_PREFIX}criaOrdemCarga&pagina&token=${token}`, {
        ordemCarga: {
          codCdd: codCdd,
          tipoCarga: selectedTipodecarga,
          codTransportadora: Number(transportadoraKey),
          clienteRetira: clienteRetira,
          codParcMotorista: Number(selectedMotorista),
          codVeiculo: Number(selectedVeiculo),
          codTipVeiculo: Number(codTipValue),
          codDestinatario: Number(selectedTomadorOrdemCarga),
          tipoWms: tipoWms,
          assoalho: assoalho,
          pesoTotal: peso.length > 0 ? Number(peso.replace(/\./g, '').replace(',', '.')) : null
        },
        nuNotas: ArraynuNotas,
      })
      .then((res: AxiosResponse<IOrdemCarga>) => {
        setOrder(res.data);
        setLoading(false);
        if (tipoWms === 'EXP') {
          setaArraySelectedItens(undefined);
        }
        Modal.confirm({
          title: 'Atenção',
          icon: <WarningOutlined />,
          content: <h3>Deseja fazer o agendamento?</h3>,
          okText: 'Sim, agendar agora',
          cancelText: 'Agendar depois',
          centered: true,

          onOk() {
            modalCriarAgendamentoRef?.current?.showModal();
          },

          async onCancel() {
            await Swal.fire({
              icon: 'success',
              title: `A ordem de carga ${res.data?.ordemCarga} foi criada com sucesso!`,
              text: 'Para dar sequência ao agendamento, acesso o menu "Ordens de carga".',
              confirmButtonAriaLabel: 'Ok',
              showConfirmButton: true,
            });

            atualizaTabelaEntrega && atualizaTabelaEntrega();
            atualizaTabelaColeta && atualizaTabelaColeta();

            dispatch(cleanOrdemCarga());
            setIsModalVisible(false);
          },
        });
      })
      .catch((err: any) => {

        setLoading(false);
        if (err.response?.data?.Erro) {
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: err.response?.data?.Erro,
          });
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: 'Erro ao criar ordem de carga',
          });
        }
      })
  };

  const resetStatus = () => {
    setLoading(false);
    setSelectedTomadorOrdemCarga(null);
    setIsModalVisible(false);
    setSelectedVeiculo(null);
    setCodTipValue(null);
    setAssoalho('');
    setSelectedTipodecarga('');
    setSelectedMotorista(null);
    setTransportadoraKey(null);
    setClienteRetira(false);
    setPeso("");
    setData([]);
  };

  const openNotification = (message: string) => {
    notification.info({
      placement: 'bottomRight',
      message: message,
    });
  };

  const disabled = () => {
    if (selectedVeiculo &&
      selectedMotorista &&
      selectedTipodecarga &&
      transportadoraKey &&
      selectedTomadorOrdemCarga) {
      return false;
    }

    return true;
  };

  const creationOrderIsDisable = () => {

    const arrayCodParceiroAutorizado = parceiros?.map(item => {
      if (item.entregaSemNota)
        return item.codParceiro;
      return null;
    })

    if (arrayCodParceiroAutorizado?.includes(Number(selectedTomadorOrdemCarga))) return disabled();
    if (itensSelected?.length === 0 && data.length > 0) return disabled();
    if (itensSelected?.length) return disabled();
    return true;
  };

  const newColectIsDisable = () => {
    if (inscricaoAtiva?.length === 0) return true;
    if (tipoWms === 'EXP' && !isPossibleNewEmptyColect && !itensSelected?.length) return true
    return false;
  }

  return (
    <>
      <div style={{ display: 'none' }}>
        <ModalCriarAgendamento
          ordemCarga={order}
          ref={modalCriarAgendamentoRef}
          setIsModalOrdemCargaVisible={setIsModalVisible}
          atualizaTabelaColeta={atualizaTabelaColeta}
          atualizaTabelaEntrega={atualizaTabelaEntrega}
        />
      </div>

      <Modal
        centered
        title={<TitlePage> Nova {tipoWms === 'EXP' ? 'coleta' : 'entrega'}</TitlePage>}
        visible={isModalVisible}
        onCancel={() => resetStatus()}
        maskClosable={false}
        closable={true}
        destroyOnClose={true}
        closeIcon={<CloseOutlined />}
        keyboard={true}
        width={1050}
        footer={[
          <Space>
            <Button key="back" type="ghost" size="middle" onClick={() => resetStatus()}>
              Cancelar
            </Button>

            <Tooltip title={creationOrderIsDisable() && 'Preencha todos os campos para continuar'}>
              <Button
                data-cy="btnCreateOrdemCarga"
                type="primary"
                loading={loading}
                disabled={creationOrderIsDisable() && !loadingAddItem}
                onClick={handleConfirmation}
              >
                Criar ordem de carga
              </Button>
            </Tooltip>
          </Space>,
        ]}
      >
        <ModalContainer>
          <Form>
            <Row gutter={24}>
              <Col md={12} sm={24} xs={24}>
                <TextLabel>
                  <StyledAsterisco />
                  Tomador ( De quem/Pra quem é a mercadoria ):
                </TextLabel>

                {perfil === ROLE.TRANSPORTADORA ? (
                  <Form.Item
                    rules={[
                      {
                        required: true,
                        message: (
                          <span style={{ color: 'red' }}>Por favor, selecione o tomador</span>
                        ),
                      },
                    ]}
                  >
                    <SelectTomadorTransp
                      setSelectedTomadorOrdemCarga={setSelectedTomadorOrdemCarga}
                      disabled={disableField}

                    />
                  </Form.Item>
                ) : (
                  <SelectInscricao data-cy="test" setProps={setSelectedTomadorOrdemCarga} disabled={disableField} />
                )}
              </Col>

              <Col md={12} sm={24} xs={24}>
                <TextLabel>
                  <StyledAsterisco />
                  Tipo de carga:
                </TextLabel>
                <Form.Item
                  data-cy="tipoCarga"
                  name="tipoCarga"
                  rules={[{ required: true, message: 'Selecione o tipo de carga' }]}
                >
                  <Select
                    onSelect={(e) => setSelectedTipodecarga(e.toString())}
                    placeholder="Selecione o tipo de carga"
                    style={{ width: '100%', textAlign: 'center' }}
                  >
                    <Option value={'F'}>Batida</Option>
                    <Option value={'R'}>Paletizada</Option>
                  </Select>
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={24}>
              <Col md={12} sm={24} xs={24}>
                <TextLabel>
                  <StyledAsterisco />
                  Transportadora:
                </TextLabel>

                <Form.Item name="transportadora" data-cy="transportadora">
                  <ModalTransportadora
                    data-cy="transportadora"
                    codTomador={Number(selectedTomadorOrdemCarga)}
                    disabled={disableField}
                    setTransportadoraKey={setTransportadoraKey}
                    setClienteRetira={setClienteRetira}
                  />
                </Form.Item>
              </Col>

              <Col md={12} sm={24} xs={24}>
                <TextLabel>
                  <StyledAsterisco />
                  Motorista:
                </TextLabel>
                <ModalMotorista disabled={false} setSelectedMotorista={setSelectedMotorista} />
              </Col>
            </Row>

            <Row gutter={24}>
              <Col md={12} sm={24} xs={24}>
                <TextLabel>
                  <StyledAsterisco />
                  Veículo:
                </TextLabel>

                <ModalVeiculo
                  disabled={false}
                  setSelectedVeiculo={setSelectedVeiculo}
                  codParceiro={transportadoraKey}
                  clienteRetira={clienteRetira}
                  setCodTipValue={setCodTipValue}
                  setAssoalho={setAssoalho}
                />
              </Col>

              {
                (isPossibleNewEmptyColect && itensSelected.length === 0 && tipoWms === 'EXP') ? <Col md={6} sm={24} xs={24}>
                  <TextLabel>
                    <StyledAsterisco />
                    Peso:
                  </TextLabel>

                  <Input suffix={"KG"} value={peso} onChange={(e) => {
                    setPeso(mask("pesoInput", e.target.value))
                  }} />

                </Col> : ""
              }


            </Row>
          </Form>

          {cddAtivo?.codCdd &&
            selectedVeiculo &&
            selectedMotorista &&
            selectedTipodecarga &&
            transportadoraKey &&
            selectedTomadorOrdemCarga ? (
            <>
              {tipoWms !== 'EXP' && (
                <ModalNovoItem
                  clienteRetira={clienteRetira}
                  selectedTranportadora={transportadoraKey}
                  selectedTomador={selectedTomadorOrdemCarga}
                />
              )}
              <br />
              <TitlePage>Documentos adicionados</TitlePage>

              <CriaPedidoEntrega
                data={itensSelected.length ? itensSelected : data}
                setData={setData}
                selectedMotorista={selectedMotorista}
                selectedVeiculo={selectedVeiculo}
                label={tipoWms === 'EXP' ? 'coleta' : 'entrega'}
              />
            </>
          ) : (
            ''
          )}
        </ModalContainer>
      </Modal>
      <Tooltip
        title={
          inscricaoAtiva?.length === 0
            ? 'Por favor, selecione o Centro de distribuição e o(s) Parceiro(s) para continuar'
            : tipoWms === 'EXP' && !isPossibleNewEmptyColect && !itensSelected?.length
              ? 'Por favor, selecione uma ou mais solicitações de retorno na lista abaixo clicando na caixinha de seleção para continuar'
              : ''
        }
        placement="bottom"
      >
        <Button
          data-cy={`btnCreate${tipoWms === 'EXP' ? 'Coleta' : 'Entrega'}`}
          className="outlineBtn"
          disabled={newColectIsDisable()}
          icon={<PlusCircleOutlined />}
          onClick={() => {
            resetStatus();
            setIsModalVisible(true);
          }}
        >
          Nova {tipoWms === 'EXP' ? 'coleta' : 'entrega'}
        </Button>
      </Tooltip>
    </>
  );
};

export default ModalCriarOrdemDeColeta;
